import StarSvg from "@assets/icons/star.svg?react";
import { FC, useState } from "react";
import Icon from "../../Icon/Icon";
import styles from "./StarRatingInput.module.css";

type StarRatingInputProps = {
  value: number;
  onChange: (value: number) => void;
  maxRating?: number;
  ariaLabelPrefix?: string;
};

export const StarRatingInput: FC<StarRatingInputProps> = ({
  value,
  onChange,
  maxRating = 5,
  ariaLabelPrefix = "Rate",
}) => {
  const [hoveredRating, setHoveredRating] = useState<number | null>(null);

  const handleRatingSelect = (nextValue: number) => {
    onChange(nextValue);
    setHoveredRating(null);
  };

  return (
    <div className={styles.stars}>
      {Array.from({ length: maxRating }, (_, index) => {
        const starValue = index + 1;
        const displayRating = hoveredRating ?? value;
        const isSelected = starValue <= displayRating;
        const isPreviewSelected =
          hoveredRating !== null &&
          starValue <= hoveredRating &&
          starValue > value;

        return (
          <button
            key={starValue}
            type="button"
            className={styles.starButton}
            onPointerDown={() => handleRatingSelect(starValue)}
            onClick={() => handleRatingSelect(starValue)}
            onMouseEnter={() => setHoveredRating(starValue)}
            onMouseLeave={() => setHoveredRating(null)}
            onFocus={() => setHoveredRating(starValue)}
            onBlur={() => setHoveredRating(null)}
            aria-label={`${ariaLabelPrefix} ${starValue} out of ${maxRating}`}
            aria-pressed={value === starValue}
          >
            {isSelected || isPreviewSelected ? (
              <Icon
                name="Star"
                className={
                  isPreviewSelected ? styles.starPreview : styles.starSelected
                }
              />
            ) : (
              <StarSvg />
            )}
          </button>
        );
      })}
    </div>
  );
};
